// extracted by mini-css-extract-plugin
module.exports = {"nav_menu":"style_nav_menu__QgbH6","menu_item":"style_menu_item__2w34Z","other_menu":"style_other_menu__1T6XK","menu_action":"style_menu_action__1QjPL"};